import { Base64 } from 'js-base64';
import { isEmpty } from 'lodash';
import Cookies from 'js-cookie';
import { getMainDomain } from './url';
import localStorage, { MODULES } from './localStorage';

const USER_MODULE = MODULES.USER;

const USER_TOKEN = 'user_token';
const IS_LOGIN = 'is_login';
const IS_SHOW_OVERDUE_PROMPT = 'is_show_overdue_prompt';
const WIW_NAME = 'wiw_name';

let userToken = '';
let expires = 7;

const parseToken = token => {
  if (isEmpty(token)) {
    return {};
  }
  const payload = token.split('.')[1];
  return JSON.parse(Base64.decode(payload));
};

const setUserToken = token => {
  const { exp, name } = parseToken(token);
  userToken = token;
  expires = new Date(exp * 1000);
  Cookies.set(USER_TOKEN, token, {
    expires,
    domain: getMainDomain()
  });
  Cookies.set(WIW_NAME, name, {
    expires,
    domain: getMainDomain()
  });
};

const getUserToken = () => {
  if (isEmpty(userToken) && Cookies.get(USER_TOKEN)) {
    userToken = Cookies.get(USER_TOKEN);
  }
  return userToken;
};

const getUserName = () => {
  const { sub } = parseToken(getUserToken());
  return sub || '';
};

const getOverdueDays = () => {
  const { passwordExpirationReminderDays } = parseToken(getUserToken());
  return passwordExpirationReminderDays || 0;
};

const getUserEmail = () => {
  const { email } = parseToken(getUserToken());
  return email;
};

const isLogin = () => Cookies.get(IS_LOGIN) === 'true';

const isShowOverduePrompt = () =>
  Cookies.get(IS_SHOW_OVERDUE_PROMPT) === 'true';

const setIsLoginTrue = () => {
  Cookies.set(IS_LOGIN, true, { expires, domain: window.location.hostname });
};

const setIsShowOverduePrompt = isShow => {
  Cookies.set(IS_SHOW_OVERDUE_PROMPT, isShow, {
    expires,
    domain: getMainDomain()
  });
};

const clearCookie = () => {
  Cookies.remove(USER_TOKEN, { domain: getMainDomain() });
  Cookies.remove(IS_LOGIN, { domain: getMainDomain() });
  Cookies.remove(IS_SHOW_OVERDUE_PROMPT, { domain: getMainDomain() });
  Cookies.remove(WIW_NAME, { domain: getMainDomain() });
  localStorage.clearModule(USER_MODULE);
};

const redirectToLogout = () => {
  const { href } = window.location;
  clearCookie();
  window.open(`/sso/logout?redirect=${href}`, '_self');
};

const redirectToLogin = () => {
  const { href } = window.location;
  clearCookie();
  window.open(`/login?redirect=${href}`, '_self');
};

const redirectToPrivilegedLogout = () => {
  clearCookie();
  window.open(`/privileged/logout`, '_self');
};

const isPrivilegedSession = () => {
  const userData = localStorage.getModule(USER_MODULE);
  return !!userData?.privilegedAccount;
};

export {
  isLogin,
  getUserName,
  getUserToken,
  parseToken,
  setUserToken,
  isShowOverduePrompt,
  setIsShowOverduePrompt,
  getOverdueDays,
  clearCookie,
  redirectToLogout,
  setIsLoginTrue,
  redirectToLogin,
  redirectToPrivilegedLogout,
  getUserEmail,
  isPrivilegedSession
};
